import { useQuery } from 'react-query';

import getSlides from '@/common/api/slides/getSlides';
import { ENDPOINT_SLIDES } from '@/common/constants';

const useSlides = ({ page, limit }) =>
  useQuery([ENDPOINT_SLIDES, page, limit], getSlides);

export default useSlides;
